import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import de from './locales/de.json';

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Fallback to English
    debug: process.env.NODE_ENV === 'development',
    lng: 'en', // Default language
    supportedLngs: ['de', 'en'],
    load: 'languageOnly', // Only load language, not region

    detection: {
      order: ['querystring', 'localStorage'], // Removed 'navigator' and 'htmlTag' to avoid browser language override
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupQuerystring: 'lng',
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false, // Disable suspense to prevent loading issues
    },
  });

export default i18n;
